import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { reducer as reduxFormReducer } from 'redux-form';
import {
  themeReducer,
  rtlReducer,
  customizerReducer,
  sidebarReducer,
  authReducer,
  roundBordersReducer,
  blocksShadowsReducer,
  getInvoiceListReducer,
  validateInvoiceListReducer,
  creteInvoiceMultiReducer,
  getDataDownloadtReducer,
  claimReducer,
  withdrawClaimReducer,
  closeClaimReducer,
  getMaintainFactorsReducer,
  employeeDetailReducer,
} from '../../redux/reducers/index';
import appConfigReducer from '../../redux/reducers/appConfigReducer';

const reducer = combineReducers({
  form: reduxFormReducer, // mounted under "form",
  theme: themeReducer,
  rtl: rtlReducer,
  roundBorders: roundBordersReducer,
  blocksShadows: blocksShadowsReducer,
  appConfig: appConfigReducer,
  customizer: customizerReducer,
  sidebar: sidebarReducer,
  user: authReducer,
  getInvoice:getInvoiceListReducer,
  validateInvoice:validateInvoiceListReducer,
  createInvoiceData:creteInvoiceMultiReducer,
  tableData: getDataDownloadtReducer,
  claim: claimReducer,
  withdrawClaim:withdrawClaimReducer,
  closeClaim: closeClaimReducer,
  getMaintainFactors:getMaintainFactorsReducer,
  employeeDetails: employeeDetailReducer
});
const store = createStore(reducer, applyMiddleware(thunk));

export default store;
